<template>
  <div class="col-lg-6">

        <!-- Reporting interval -->

        <h4 class="card-title">{{ $t('monitoring.field_title_keyword_for_better_identifying_your_project') }}</h4>
        <h5 class="card-subtitle">{{ $t('monitoring.field_subtitle_type_of_priority_area') }}</h5>
        <div class="form-group">
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.type_of_priority_keyword_marine_protected_conserved_area"
                >
                {{ $t('monitoring.field_type_of_priority_keyword_marine_protected_conserved_area') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.type_of_priority_keyword_marine_managed_areas"
                >
                {{ $t('monitoring.field_type_of_priority_keyword_marine_managed_areas') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.type_of_priority_keyword_terrestrial_protected_conserved_area"
                >
                {{ $t('monitoring.field_type_of_priority_keyword_terrestrial_protected_conserved_area') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.type_of_priority_keyword_indigenous_and_community_conserved_area"
                >
                {{ $t('monitoring.field_type_of_priority_keyword_indigenous_and_community_conserved_area') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.type_of_priority_keyword_privately_protected_area"
                >
                {{ $t('monitoring.field_type_of_priority_keyword_privately_protected_area') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.type_of_priority_keyword_conservancy"
                >
                {{ $t('monitoring.field_type_of_priority_keyword_conservancy') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.type_of_priority_keyword_key_landscape_for_conservation"
                >
                {{ $t('monitoring.field_type_of_priority_keyword_key_landscape_for_conservation') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.type_of_priority_keyword_kbas"
                >
                {{ $t('monitoring.field_type_of_priority_keyword_KBAs') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.type_of_priority_keyword_transboundary_areas"
                >
                {{ $t('monitoring.field_type_of_priority_keyword_transboundary_areas') }}
            </base-checkbox>
        </div>
        <h5 class="card-subtitle">{{ $t('monitoring.field_subtitle_primary_objective') }}</h5>
        <div class="form-group">
            <radio name="model.frequency"
                value="governance"
                v-model="MonitoringForm.model.grant_agreement.keyword_primary_objective"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                >
                <label>{{ $t('monitoring.field_primary_objective_keyword_governance') }}</label>
            </radio>
            <radio name="model.frequency"
                value="management_effectiveness"
                v-model="MonitoringForm.model.grant_agreement.keyword_primary_objective"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                >
                <label>{{ $t('monitoring.field_primary_objective_keyword_management_effectiveness') }}</label>
            </radio>
            <radio name="model.frequency"
                value="livelihoods"
                v-model="MonitoringForm.model.grant_agreement.keyword_primary_objective"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                >
                <label>{{ $t('monitoring.field_primary_objective_keyword_livelihoods') }}</label>
            </radio>
        </div>
        <h5 class="card-subtitle">{{ $t('monitoring.field_subtitle_target_groups') }}</h5>
        <div class="form-group">
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.target_groups_keyword_local_communities"
                >
                {{ $t('monitoring.field_target_groups_keyword_local_communities') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.target_groups_keyword_indigenous_people"
                >
                {{ $t('monitoring.field_target_groups_keyword_indigenous_people') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.target_groups_keyword_youth"
                >
                {{ $t('monitoring.field_target_groups_keyword_youth') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.target_groups_keyword_women"
                >
                {{ $t('monitoring.field_target_groups_keyword_women') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.target_groups_keyword_private_sector"
                >
                {{ $t('monitoring.field_target_groups_keyword_private_sector') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.target_groups_keyword_farmers_fishermen"
                >
                {{ $t('monitoring.field_target_groups_keyword_farmers_fishermen') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.target_groups_keyword_national_local_pa_agency"
                >
                {{ $t('monitoring.field_target_groups_keyword_national_local_pa_agency') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.target_groups_keyword_national_government"
                >
                {{ $t('monitoring.field_target_groups_keyword_national_government') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.target_groups_keyword_subnational_governments"
                >
                {{ $t('monitoring.field_target_groups_keyword_subnational_governments') }}
            </base-checkbox>
        </div>
        <h5 class="card-subtitle">{{ $t('monitoring.field_subtitle_main_activity_focus') }}</h5>
        <div class="form-group row">
            <div class="col-6">
                <base-checkbox
                    name="checkbox"
                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                    v-model="MonitoringForm.model.grant_agreement.field_main_activity_focus_keyword_management_plan"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_management_plan') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                    v-model="MonitoringForm.model.grant_agreement.field_main_activity_focus_keyword_enforcement"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_enforcement') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                    v-model="MonitoringForm.model.grant_agreement.field_main_activity_focus_keyword_legal_framework_regulation"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_legal_framework_regulation') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                    v-model="MonitoringForm.model.grant_agreement.field_main_activity_focus_keyword_illegal_activities"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_illegal_activities') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                    v-model="MonitoringForm.model.grant_agreement.field_main_activity_focus_keyword_co_management"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_co_management') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                    v-model="MonitoringForm.model.grant_agreement.field_main_activity_focus_keyword_participation"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_participation') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                    v-model="MonitoringForm.model.grant_agreement.field_main_activity_focus_keyword_livelihoods_alternative_economic_activities"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_livelihoods_alternative_economic_activities') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                    v-model="MonitoringForm.model.grant_agreement.field_main_activity_focus_keyword_sustainable_development"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_sustainable_development') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                    v-model="MonitoringForm.model.grant_agreement.field_main_activity_focus_keyword_landscape_approach"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_landscape_approach') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                    v-model="MonitoringForm.model.grant_agreement.field_main_activity_focus_keyword_eco_tourism"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_eco_tourism') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                    v-model="MonitoringForm.model.grant_agreement.field_main_activity_focus_keyword_sustainable_financing"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_sustainable_financing') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                    v-model="MonitoringForm.model.grant_agreement.field_main_activity_focus_keyword_threatened_species"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_threatened_species') }}
                </base-checkbox>
            </div>

            <div class="col-6">
                <base-checkbox
                    name="checkbox"
                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                    v-model="MonitoringForm.model.grant_agreement.field_main_activity_focus_keyword_human_wildlife_conflict"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_human_wildlife_conflict') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                    v-model="MonitoringForm.model.grant_agreement.field_main_activity_focus_keyword_ecosystem_habitat_restoration"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_ecosystem_habitat_restoration') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                    v-model="MonitoringForm.model.grant_agreement.field_main_activity_focus_keyword_invasive_alien_species"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_invasive_alien_species') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                    v-model="MonitoringForm.model.grant_agreement.field_main_activity_focus_keyword_survey_data_knowledge_management"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_survey_data_knowledge_management') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                    v-model="MonitoringForm.model.grant_agreement.field_main_activity_focus_keyword_protected_area_management_effectiveness_pame"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_protected_area_management_effectiveness_pame') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                    v-model="MonitoringForm.model.grant_agreement.field_main_activity_focus_keyword_protected_area_governance_effectiveness_page"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_protected_area_governance_effectiveness_page') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                    v-model="MonitoringForm.model.grant_agreement.field_main_activity_focus_keyword_capacity_building"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_capacity_building') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                    v-model="MonitoringForm.model.grant_agreement.field_main_activity_focus_keyword_awareness_education"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_awareness_education') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                    v-model="MonitoringForm.model.grant_agreement.field_main_activity_focus_keyword_climate_adaptation_mitigation_resilience"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_climate_adaptation_mitigation_resilience') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                    v-model="MonitoringForm.model.grant_agreement.field_main_activity_focus_keyword_monitoring_patrol_equipment"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_monitoring_patrol_equipment') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                    v-model="MonitoringForm.model.grant_agreement.field_main_activity_focus_keyword_human_rights"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_human_rights') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                    v-model="MonitoringForm.model.grant_agreement.field_main_activity_focus_keyword_green_list"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_green_list') }}
                </base-checkbox>
            </div>
        </div>

        <h4 class="card-title">{{ $t('monitoring.field_title_support_to_local_communities') }}</h4>
        <div class="form-group">
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.support_keyword_a"
                >
                {{ $t('monitoring.field_support_keyword_01') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.support_keyword_b"
                >
                {{ $t('monitoring.field_support_keyword_02') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.support_keyword_c"
                >
                {{ $t('monitoring.field_support_keyword_03') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.support_keyword_d"
                >
                {{ $t('monitoring.field_support_keyword_04') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.support_keyword_e"
                >
                {{ $t('monitoring.field_support_keyword_05') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.support_keyword_f"
                >
                {{ $t('monitoring.field_support_keyword_06') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.support_keyword_g"
                >
                {{ $t('monitoring.field_support_keyword_07') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.support_keyword_h"
                >
                {{ $t('monitoring.field_support_keyword_08') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.support_keyword_i"
                >
                {{ $t('monitoring.field_support_keyword_09') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.support_keyword_j"
                >
                {{ $t('monitoring.field_support_keyword_10') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.support_keyword_k"
                >
                {{ $t('monitoring.field_support_keyword_11') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.support_keyword_l"
                >
                {{ $t('monitoring.field_support_keyword_12') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.support_keyword_m"
                >
                {{ $t('monitoring.field_support_keyword_13') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                :disabled="loggedUser.role !== UserRoles.ADMIN && loggedUser.role !== UserRoles.REGIONAL_ADMIN && loggedUser.role !== UserRoles.APPLICANT"
                v-model="MonitoringForm.model.grant_agreement.support_keyword_n"
                >
                {{ $t('monitoring.field_support_keyword_14') }}
            </base-checkbox>
        </div>


        <!-- % of the total budget -->
        <!-- <div class="form-group">
            <textarea
                class="form-control"
                name="grant_agreement.percent_of_total_budget"
                v-model="MonitoringForm.model.grant_agreement.percent_of_total_budget"
                v-validate="'required'"
                :error="getError('grant_agreement.percent_of_total_budget')"
                :data-vv-as="$t('monitoring.field_title_percent_of_total_budget')"
                :label="$t('monitoring.field_title_percent_of_total_budget')"
                :placeholder="$t('monitoring.field_title_percent_of_total_budget')"
                >
            </textarea>
        </div> -->
    </div>
</template>

<script>

export default {
    props: {
        loggedUser: Object,
        UserRoles: Object,
        MonitoringForm: Object
    }

}

</script>
<style lang="scss" scoped>
.grant-agreement
{
    counter-reset: title_counter;
    // counter-reset: subtitle_counter;

    .card-title
    {
        counter-increment: title_counter;
        counter-reset: subtitle_counter;

        &:before
        {
            content: counter(title_counter) '. '
        }
    }

    .card-subtitle
    {
        margin: 10px 0;
        counter-increment: subtitle_counter;

        &:before
        {
            content: counter(title_counter) '.' counter(subtitle_counter) '. '
        }
    }
}
</style>
